/**
 * 员工管理
 */

import BaseAuthClient from './baseAuth';

class StaffClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const staffClient = new StaffClient();

export default staffClient;

// 获取项目成员
export const getComicStaffList = (option: any) => staffClient.get(`/v1/user/getmemberlist`, option);

// 获取部门成员
export const getDepartUserList = (option: any) => staffClient.get(`/v1/user/getuserlist`, option);

// 员工列表(设定员工目标使用)
export const getTargetStaffList = (option: any) => staffClient.get(`/v1/user/getusertarget`, option);

// 更新员工目标
export const updateStaffTarget = (option: any) => staffClient.put(`/v1/user/editusertarget`, option);

// 设定员工目标
export const setStaffTarget = (option: any) => staffClient.put(`/v1/user/setusertarget`, option);

// 员工目标详情
export const getStaffTargetDetail = (option: any) => staffClient.get(`/v1/user/getusertargetbyuid`, option);

// 员工详情
export const getStaffDetail = (option: any) => staffClient.get(`/v1/user/userinfo`, option);

// 设置员工价格
export const setUserPrice = (option: any) => staffClient.put(`/v1/user/setuserprice`, option);
